import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoTariffPreference extends Component {

    render() {
        const { tariffPreference } = this.props;
        const summary = getTitleSummary(tariffPreference)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Тарифные преференции'],
                    rows: summary
                }}
                expanded={(tariffPreference.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Страны',
                        'Наличие',
                        'Примечание',
                        'Нормативный документ'
                    ],
                    rows: tariffPreference.map(({ to_date = null, country_classification = {}, exists = false, order, order_date, orders_info = null, description = null }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        country_classification.description,
                        exists ? 'Да' : 'Нет',
                        description,
                        formatOrder(order, order_date, orders_info)
                    ]))
                }}
            />
        );
    }
}

function getTitleSummary(items) {
    return items.length !== 0 ? [['есть']] : null;
}






// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoTariffPreference.js